import useAtomPlayground from './useAtomPlayground'
import Button from '../../../../control/button/button'

type DialogPlaygroundType = ReturnType<typeof useAtomPlayground>
const AtomPlaygroundView = (props: DialogPlaygroundType) => {
    const { playgroundStore, onClickSetFirstName } = props
    return (
        <div>
            <h1> Use Atom Example:</h1>
            <div>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={onClickSetFirstName}
                    style={{ margin: 10, marginLeft: 0 }}
                >
                    Set First Name
                </Button>
                <label>
                    {playgroundStore.profile.firstName} {playgroundStore.profile.lastName}
                </label>
            </div>
        </div>
    )
}

const AtomPlayground = () => {
    const atomPlayground = useAtomPlayground()
    return <AtomPlaygroundView {...atomPlayground} />
}

export default AtomPlayground
